import CashApi from "./CashApi";

export default CashApi;
